/* import __COLOCATED_TEMPLATE__ from './verify.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();